<span>
  {{ displayValue }}

  <span class="round-counter" [ngClass]="{ 'round-counter-empty': empty }">
    {{ data?.motivos_rejeicao_item?.length ?? 0 }}
  </span>
</span>
